const getters = {
  isRequesting: (state) => state.isRequesting,
  registrationEmail: (state) => state.registrationEmail,
  regEmailBillingEnabled: (state) => state.regEmailBillingEnabled,
  accountingEmail: (state) => state.accountingEmail,
  accountingEmailEnabled: (state) => state.accountingEmailEnabled,
};

export default getters;
